export default __webpack_public_path__ + "static/media/dribbble-24-px.9f21bdd6.svg";